// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SettingTwoToneSvg from "@fishx/icons-svg/es/asn/SettingTwoTone";
import FishxIcon from '../components/FishxIcon';

var SettingTwoTone = function SettingTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: SettingTwoToneSvg
  }));
};

SettingTwoTone.displayName = 'SettingTwoTone';
export default React.forwardRef(SettingTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/SettingTwoTone.js
// module id = 4094
// module chunks = 0